import { render } from "./S110_AGBConfirmDialog.vue?vue&type=template&id=77702ff4&ts=true"
import script from "./S110_AGBConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./S110_AGBConfirmDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__